import React from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import { baseURL } from "../../constants/Api";
import BgEvent from "../../images/hotelEvent.png";
import EventModal from "./EventModal";
import Increment from "../../images/increment.svg";
import Decrement from "../../images/decrement.svg";
import EventForm from "../../components/EventForm";
import RedirectModal from "../../components/RedirectModal";
import BackButton from "../bars/BackButton";
import Skeleton from "../../components/skeletons/skeleton";
import Emty from "../../components/emty-state/Emty";
import dateFormat from "dateformat";
import { CurrencySymbol, dateFormater, extractTimeFromDate, handleOffers } from "../../utils/util";
import { EventPageView } from "../../utils/Analytics";

function Event() {
  const location = useLocation();
  const [eventdata, SetEventdata] = useState([]);
  const [hotelData, SethotelData] = useState([]);
  const [showEventModal, SetShowEventModal] = useState(false);
  const currentUrl = window.location.href;
  const urlArray = currentUrl.split("/");
  const hotelId = urlArray[urlArray.length - 1];
  const [modalName, SetModalName] = useState("");
  const [modalImg, SetModalImg] = useState("");
  const [modalDescription, SetModalDescription] = useState("");
  const [modalDate, SetModalDate] = useState("");
  const [ticketBooked, setTicketBooked] = useState(false);
  const [selectedEventData, setSelectedEventData] = useState({});
  const navigate = useNavigate();
  const isCheckedIn = localStorage.getItem("isCheckedIn");
  const [showRedirect, setShowRedirect] = useState(false);
  const [loading, setLoading] = useState(false);
  const [emty, setEmty] = useState(false);
  const [promotionId, setPromotionId] = useState(null)
  const EventIdFromUrl = currentUrl.split('EventId-')[1]
  const [highlights,sethighlights] = useState('');
  // console.log("EventIdFromUrl=====================================",EventIdFromUrl)
  const getEvent = async () => {
    setLoading(true);
    try {
      await axios({
        method: "get",
        url: `${baseURL}/api/events/` + hotelId,

        headers: { "Content-Type": "application/json" },
      }).then(function (response) {
        console.log("response.data.data event========ttttttt=====================",response.data.data)
        if (EventIdFromUrl) {
          const reorderedSpaItems = [
            ...response.data.data.filter(item => parseInt(item.id) === parseInt(EventIdFromUrl)),
            ...response.data.data.filter(item => parseInt(item.id) !== parseInt(EventIdFromUrl))
          ];
          // console.log("eventdatefrom filter============",reorderedSpaItems)
          SetEventdata(reorderedSpaItems);
        }else{

          SetEventdata(response.data.data);
        }

        if (response.data.data.length === 0) {
          setEmty(true);
        }

        setLoading(false);

        // if (response.data.data.length == 0) {
        //     // console.log("hii");
        //     setAvailable(true);
        // }
        // SethotelData(response.data.data);
      });
    } catch {
      setLoading(false);
    }
  };
  useEffect(() => {
    // console.log("eventdata============",eventdata)
    if (eventdata.length === 0) {
          console.log("Zero");
          setTicketBooked(false);
          SetShowEventModal(false);
    } else {
      const promoObject = eventdata.find((promo) => promo.id == EventIdFromUrl);
      if(promoObject){
        setSelectedEventData(promoObject);
        setTicketBooked(true);
        SetShowEventModal(false);
      }
    }
  }, [eventdata]);

  useEffect(() => {
    window.scrollTo(0, 0);

    if (location?.state?.promotionId) {
      setPromotionId(location?.state?.promotionId)
    }
    getEvent();
  }, []);

  const handleEventModal = (eventData) => {
    // if (isCheckedIn === "true") {
    //   setSelectedEventData(eventData);
    //   SetModalImg(eventData.image);
    //   SetModalDescription(eventData.description);
    //   SetModalName(eventData.name);
    //   SetModalDate(eventData.from);
    //   SetShowEventModal(true);
    // } else {
    //   setShowRedirect(true);
    // }
    console.log("eventData=============================",eventData)
    setSelectedEventData(eventData);
    SetModalImg(eventData.image);
    SetModalDescription(eventData.description);
    SetModalName(eventData.name);
    SetModalDate(eventData.from);
    SetShowEventModal(true);
    sethighlights(eventData.highlights);
  };

  const handleBookTickets = () => {
    setTicketBooked(true);
    SetShowEventModal(false);
  };

   useEffect(() => {
      EventPageView();
     }, []);

       // currency setup
     const currencySymbol = CurrencySymbol();

  return (
    <div>
      {!loading ? (
        <div>
          {ticketBooked == false ? (
            <div className="pb-28 relative">
              <img
                className="w-screen sm:h-[230px] h-[117px]"
                src={BgEvent}
                alt="bgHotelguide"
              />
              <div className="absolute top-3 left-3">
                <BackButton whiteTheme={true} />
              </div>
              <div className="section-wrap mx-4 mt-4">
                <div className="guestName text-left">Events</div>
                <div className="text-[#9A9A9A] font-medium text-[11px] text-left mt-2">
                  Book your tickets
                </div>
                <div>
                  <div className="gridTab grid grid-flow-row grid-cols-2 gap-3 gap-x-4 mt-3">
                    {eventdata.map((eventInfo, index) => (
                      <button
                        onClick={() => handleEventModal(eventInfo)}
                        key={index}
                        className="flex flex-col p-2 w-full bg-[#342F4F] rounded-md  hover:shadow-lg  transition-all"
                      >
                        <div className="w-full  flex justify-center items-stretch bg-gray-200 rounded-md overflow-hidden h-[106px] sm:h-[160px] ">
                          <img
                            width="100%"
                            height="100%"
                            className="flex items-stretch bg-contain object-cover transition w-full h-full"
                            src={eventInfo.image}
                            alt="hotelGuide"
                          ></img>
                        </div>
                        <div className=" mt-2 sm:text-base text-[14px] font-medium  truncate text-left w-[90%]" title= {eventInfo.name}>
                          {eventInfo.name}
                        </div>
                        <div className="text-xs">
                        {eventInfo?.rate > 0 ?  <>
                         { eventInfo?.offer ? 
                                  <span>
                                        <span className="line-through text-gray-400">{currencySymbol} {eventInfo?.rate}</span>
                                        <span className="text-white ml-2">{currencySymbol} {handleOffers(eventInfo?.rate, eventInfo?.offer)}</span>    
                                  </span>
                                  
                           : <span className=" ">{currencySymbol} {eventInfo?.rate}</span>}</>
                          
                           : "Free"}
                        </div>
                        <div className="text-[#9A9A9A] font-medium text-[11px] text-left mt-1">
                          {dateFormater(eventInfo.from) === dateFormater(eventInfo.to) ?   <span className="mr-1">{dateFormater(eventInfo.from)} </span> :<>
                         <span>{dateFormater(eventInfo.from)} </span> - <span>{dateFormater(eventInfo.to)} </span>
                          </>
                         }
                        </div>
                        <div className="text-[#9A9A9A] font-medium text-[11px] text-left mt-1">
                         (<span>{extractTimeFromDate(eventInfo.from)}</span>-<span>{extractTimeFromDate(eventInfo.to)}</span>)
                        </div>
                      </button>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className="">
              <EventForm selectedEventData={selectedEventData} promotionId={promotionId} />
            </div>
          )}


          {showEventModal && (
            <EventModal
              Name={modalName}
              Date={modalDate}
              to={selectedEventData.to}
              description={modalDescription}
              highlights={highlights}
              image={modalImg}
              hide={() => SetShowEventModal(false)}
              onBookTickets={handleBookTickets}
            />
          )}

          {emty && <Emty item="Events" />}
        </div>
      ) : (
        <Skeleton type="page" />
      )}
    </div>
  );
}

export default Event;
